import { useContext, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { FapAppContext } from '../../../context/fap-app.context';
import {
  appHomePage,
  maxSelectedContractors,
} from '../../../config/fapApp.config';
import bem from '../../../utils/bem';
import useWindowWidth from '../../../hooks/useWindowWidth';
import { initIndex } from '../../../Callbacks/algoliaHelper/searchClient';
import contractorPropsController from '../ResultsPage/contractorPropsController';
import ContractorTray from '../../../Components/Organisms/ContractorTray';
import CheckboxButton from '../../../Components/Atoms/FormComponents/CheckboxButton';
import RemoveContractorModal from '../../../Components/Molecules/Cards/ContractorCard/removeContractorModal';
import {
  openModalHandler,
  closeModalHandler,
} from '../../../utils/handleModalActions';

const NodePage = () => {
  const {
    selectedLocation: savedLocation,
    agentServices,
    qualifications,
    contractorsTray,
    setContractorsTray,
    commonSettings,
    algoliaSettings,
    addToEstimateAnalytics,
  } = useContext(FapAppContext);
  const { breakpoint } = useWindowWidth();
  const [portalTarget, setPortalTarget] = useState(null);
  const [contractor, setContractor] = useState(null);
  useEffect(() => {
    const index = initIndex(algoliaSettings.algolia_index);
    // eslint-disable-next-line no-unused-vars
    let ignore = false;
    if (commonSettings?.currentNodeId && agentServices && qualifications) {
      index
        .search('', {
          filters: `nid=${commonSettings.currentNodeId.trim()}`,
        })
        .then((res) => {
          const contractors = res.hits.map((hit) => {
            const contractorData = contractorPropsController(
              hit,
              agentServices,
              qualifications,
              savedLocation ? savedLocation?.[0]?.geometry?.location : '',
            );
            return contractorData;
          });
          setContractor(contractors[0]);
        });
    }
    return () => {
      ignore = true;
    };
  }, []);
  useEffect(() => {
    const elementId = breakpoint.isMobile
      ? 'add-company-button-mobile'
      : 'add-company-button-desktop';
    const target = document.getElementById(elementId);
    setPortalTarget(target);
  }, [breakpoint.isMobile]);
  const id = Number(commonSettings?.currentNodeId);
  const isSelected =
    contractorsTray && contractorsTray.find((el) => el.id === id);
  const isButtonDisabled =
    contractorsTray && contractorsTray.length >= maxSelectedContractors;
  const componentClassName = 'fap-node-page';

  const onAddContractorHandler = () => {
    const oldTray = contractorsTray;
    const newTray = [...oldTray, contractor];
    setContractorsTray(newTray, agentServices, qualifications, savedLocation);
  };

  const onRemoveContractorHandler = (cid) => {
    const oldTray = contractorsTray;
    if (oldTray.length) {
      const newTray = oldTray.filter((i) => i.id !== cid);
      setContractorsTray(newTray, agentServices, qualifications, savedLocation);
    }
  };

  const onCheckUncheckHandler = (v) => {
    if (v) {
      onAddContractorHandler();
      addToEstimateAnalytics(contractor.title, 'find_a_pro_contractor_profile');
    }
  };

  const onInputClickHandler = (e) => openModalHandler(e);

  const onCloseModalHandler = (e) => closeModalHandler(e);

  const AddButton = () => (
    <div className={bem('check-btn', [], componentClassName)}>
      <CheckboxButton
        id={`add-to-compare-${id}`}
        onChange={(v) => onCheckUncheckHandler(v)}
        disabled={!contractor || (!isSelected && isButtonDisabled)}
        isSelected={isSelected}
        tooltip={commonSettings.contractor_tray_tooltip}
        modalId={`modal__remove-contractor--${id}-checkbox`}
        inputExtra={[isSelected ? 'js-modal-open' : '']}
        inputOnClick={(e) => onInputClickHandler(e)}
      />
      <RemoveContractorModal
        onRemoveHandler={() => onRemoveContractorHandler(id)}
        title={contractorsTray.find((el) => el.id === id)?.title}
        modalId={`modal__remove-contractor--${id}-checkbox`}
        onCancelHandler={(e) => onCloseModalHandler(e)}
        onCloseHandler={(e) => onCloseModalHandler(e)}
      />
    </div>
  );

  return (
    <>
      <ContractorTray
        contractors={contractorsTray}
        onRemove={(cid) => onRemoveContractorHandler(cid)}
        estimateLink={`${appHomePage}/get-an-estimate`}
        contratorAddLink={`${appHomePage}/results`}
        className={bem('contractor-tray', [], componentClassName, [])}
        offsetSelectors="#toolbar-bar, #toolbar-item-administration-tray, .header"
      />
      {portalTarget && createPortal(<AddButton />, portalTarget)}
    </>
  );
};

export default NodePage;
